export const INPUT_BORDER_COLOR = '#dadada';
export const WHITE_COLOR = '#FFFFFF';

export const TD_PRIMARY_GREEN = '#008A00';
